import {useState} from 'react';

import sessionStorageService from '../../services/DataStorageService/SessionStorageService';


/**
 * Provides session storage backed useState functionality
 *
 * @param storageKey {string} Session storage key
 * @param initialState {any|function} Initial state
 */
function useSessionState(storageKey, initialState) {

    const [data, setData] = useState(() => {

        return sessionStorageService.get(
            storageKey,
            typeof initialState === 'function'
                ? initialState()
                : initialState
        );
    });

    return [
        data,
        newData => {
            setData(newData);
            sessionStorageService.set(storageKey, newData);
        }
    ];
}


export default useSessionState;
